import { create } from "zustand";
import { persist } from "zustand/middleware";
import { newId } from "../lib/id";

/** A flat the user is actually considering. */
export interface Candidate {
  id: string;
  label: string;
  lon: number;
  lat: number;
  /** What the seller is asking, in euros. Optional — often unknown at first. */
  askingPrice?: number;
  /** Surface in m², so the asking €/m² can be compared with what sold nearby. */
  surface?: number;
  notes?: string;
  /** Readings sampled from the map when the candidate was saved. */
  localMedian?: number;
  green?: number;
  air?: number;
  noise?: number;
  addedAt: number;
}

interface ShortlistState {
  candidates: Candidate[];
  add: (c: Omit<Candidate, "id" | "addedAt">) => void;
  update: (id: string, patch: Partial<Candidate>) => void;
  remove: (id: string) => void;
}

export const useShortlistStore = create<ShortlistState>()(
  persist(
    (set) => ({
      candidates: [],
      add: (c) =>
        set((s) => ({
          candidates: [
            ...s.candidates,
            { ...c, id: newId(), addedAt: Date.now() },
          ],
        })),
      update: (id, patch) =>
        set((s) => ({
          candidates: s.candidates.map((c) =>
            c.id === id ? { ...c, ...patch } : c,
          ),
        })),
      remove: (id) =>
        set((s) => ({ candidates: s.candidates.filter((c) => c.id !== id) })),
    }),
    // Kept in the browser: a shortlist is personal, and there is no account
    // system to attach it to.
    { name: "mete-shortlist" },
  ),
);
